<template>
  <Header />
  <div class="home">
    <div class="container">
      <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-0 col-0">
          <div v-if="!isMobileOrTablet">
            <div v-if="getReferrerDoorInfo && getReferrerDoorInfo.length > 0 && getReferrerDoorInfo[0]">
              <div style="margin-bottom: 10px;">
                Выбранная вами дверь
              </div>
              <div>
                <img :src="getLink(getReferrerDoorInfo[0].image)" alt="" style="width: 100%;">
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-12 col-12">
          <div class="upload-section">
            <h3>
              Узнайте как выглядит эта дверь в вашем интерьере за три шага!
            </h3>
            <div class="list">
              <div class="list-number">
                <div class="list-number-text">
                  1
                </div>
              </div>
              <div class="list-text">
                Сделайте фото вашей двери.
              </div>
            </div>
            <div class="list">
              <div class="list-number">
                <div class="list-number-text">
                  2
                </div>
              </div>
              <div class="list-text">
                Загрузите фото в конструктор.
              </div>
            </div>
            <div class="list">
              <div class="list-number">
                <div class="list-number-text">
                  3
                </div>
              </div>
              <div class="list-text">
                Выберите область, редактируйте и меняйте параметры двери!
              </div>
            </div>
            <!--<div class="list">
              <div class="list-number">
                <div class="list-number-text">
                  4
                </div>
              </div>
              <div class="list-text">

              </div>
            </div>-->
            <!---<div class="show-preview-door" v-if="isMobileOrTablet">
              <div v-if="getReferrerDoorInfo && getReferrerDoorInfo.length > 0 && getReferrerDoorInfo[0]">
                <div style="margin-bottom: 10px;">
                  Выбранная вами дверь
                </div>
                <div>
                  <img :src="getLink(getReferrerDoorInfo[0].image)" alt="" style="width: 100%; max-height: 350px;">
                </div>
              </div>
              <div v-if="settings.mobile_video">
                <div v-if="!settings.mobile_poster">
                  <iframe :src="settings.mobile_video" width="300" height="150"></iframe>
                </div>
                <div v-else>
                  <div v-if="!playVideo" class="show-preview-wrapper" @click="playVideo = true;">
                    <img src="@/assets/icon/start-video.png" alt="" class="video-start">
                    <img :src="settings.mobile_poster" alt="" class="video-poster">
                  </div>
                  <iframe v-else :src="settings.mobile_video" width="300" height="150"></iframe>
                </div>
              </div>
            </div>-->
            <DropFile/>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-0 col-0">
          <div v-if="!isMobileOrTablet">
            <div v-if="settings.video">
              <div v-if="!settings.desktop_poster">
                <iframe :src="settings.video" width="300" height="150"></iframe>
              </div>
              <div v-else>
                <div v-if="!playVideo" class="show-preview-wrapper" @click="playVideo = true;">
                  <img src="@/assets/icon/start-video.png" class="video-start" alt="">
                  <img :src="settings.desktop_poster" alt="" class="video-poster">
                </div>
                <iframe v-else :src="settings.video" width="300" height="150"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<FabricComponent />-->
  </div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import DropFile from '@/components/DropFile.vue'
import Header from '@/components/include/Header.vue'
//import FabricComponent from '@/components/FabricComponent.vue'
import {mapGetters} from "vuex";
import { baseUrlStorage } from "@/services/config";
import { getSettings } from "@/services/methods";

export default {
  name: 'HomeView',
  components: {
    DropFile,
    Header
  },
  data() {
    return {
      settings: {},
      playVideo: false,
      displayMobile: false,
    };
  },
  created() {
    this.getGlobalSettings();
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  computed: {
    ...mapGetters(['getReferrerDoorInfo']),
    isMobileOrTablet() {
      let check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  methods: {
    getLink(path) {
      return baseUrlStorage + path;
    },
    async getGlobalSettings() {
      const response = await getSettings();
      const { settings } = response.data;
      settings.forEach((item) => {
        this.settings[item.key] = item.value
      });
    },
    onResize() {
      this.displayMobile = (window.innerHeight < 1000);
    }
  },
}
</script>

<style media="screen" lang="scss">
  .upload-section{
    padding: 35px;
    h3{
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;
      /* identical to box height */
      color: #4E4E4C;
      margin-bottom: 30px;
    }

    h2{
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      color: #4E4E4C;
      margin-bottom: 30px;
    }

    .list{
      display: flex;
      margin-bottom: 20px;

      &-text{
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;

        color: #4E4E4C;
      }

      &-number{
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 24px;
        /* identical to box height */
        color: #FFFFFF;
        background: #3498DB;
        height: 40px;
        width: 40px;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 15px;

        &-text{
          display: flex;
          justify-content: center;
        }
      }
    }
  }
  .back-link-a{
    text-decoration: none;
  }
  .back-link{
    border-left: 3px solid #E5E5E5;
    border-bottom: 1px solid #E5E5E5;
    display: flex;
    padding-left: 25px;
    &-item{
      padding: 15px 0px;
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 21px;
      color: #969696;
      margin-right: 10px;
    }
  }
  .upload-section{
    background: #F4F4F4;
    border-radius: 16px;
  }
  .show-preview-door {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .show-preview-wrapper {
    width: 300px;
    height: 150px;
    position: relative;
    cursor: pointer;
    .video-start {
      width: 40px;
      height: 40px;
      position: absolute;
      top: 37%;
      left: 43%;
    }
    .video-poster {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  @media screen and (max-width: 1000px){
    .list-text{
      width: 80%;
    }
    .upload-section{
      margin-top: 20px;
    }
  }
</style>
